<svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" [ngClass]="{
  'arrow-up': orientation === 'UP',
  'arrow-down': orientation === 'DOWN'
}">
  <path [style]="'fill: ' + colorHex[color]"
    d="M.252 10.664a1 1 0 01.083-1.412l4.159-3.696L.335 1.858A1 1 0 111.664.363l5 4.444a1.003 1.003 0 010 1.496l-5 4.445a1.001 1.001 0 01-1.412-.084z" />
</svg>
